function isEligibleForDevice(experiment, userAgent) {
  // Based on examples from http://www.webapps-online.com/online-tools/user-agent-strings
  const isAndroid = userAgent.match(/Android/i),
    isMobile =
      isAndroid && userAgent.match(/Mobile/i)
      || userAgent.match(/iPhone/i)
      || userAgent.match(/iPod/i)
      || userAgent.match(/webOS/i)
      || userAgent.match(/BlackBerry/i)
      || userAgent.match(/Windows Phone/i),
    isTablet =
      isAndroid && userAgent.match(/Tablet/i)
      || userAgent.match(/Tablet/i)
      || userAgent.match(/iPad/i)

  if (isMobile) {
    return experiment.isMobile
  }

  if (isTablet) {
    // TODO: Android tablets are hard to detect - consider triggering this logic again on client side based on viewport
    return experiment.isTablet
  }

  // If Android device can't be recognized either it Mobile or Tablet - fallback to first type set
  if (isAndroid) {
    return experiment.isMobile || experiment.isTablet
  }

  // If device can't be recognized at all assume it is not eligible
  return experiment.isDesktop || false
}

const isEligibleForOrganicTraffic = (experiment, cookies) => {
  // Check if flag not on or someone set it to false for some reason
    if (!experiment.allowOnlyOrganicTraffic) {
      return true
    }
    const allCookies = cookies.getAll(),
      utmParamsFromCookie = Object.keys(allCookies).filter(key => key.match(/^utm_/g))

    return utmParamsFromCookie.length === 0
  },

  isEligibleForUTMTraffic = (experiment, cookies) => {
  // Check if flag not on or someone set it to false for some reason
    if (!experiment.allowOnlyUTMTraffic) {
      return true
    }
    const allCookies = cookies.getAll(),
      utmParamsFromCookie = Object.keys(allCookies).filter(key => key.match(/^utm_/g) && key !== 'utm_referrer')

    return utmParamsFromCookie.length > 0
  },

  // Check to see if experiment is running or triggerd by specifc themes
  isExperimentEnabled = (experiment) => {
    return experiment.isRunning
  },

  // Check to see if experiment is active inside experiments list
  checkActiveExperiment = (experimentIdsList, experimentId) => {
    return experimentIdsList.includes(experimentId)
  }

export {
  isEligibleForDevice,
  isEligibleForOrganicTraffic,
  isEligibleForUTMTraffic,
  isExperimentEnabled,
  checkActiveExperiment
}
